import {renderIndexPage} from "./render-index-page";
import {initPage} from "./init-page";

window.addEventListener(`load`, () => {
  initPage();
  renderIndexPage();
});
